import { useMutation } from '@tanstack/react-query';

import type {
  CreateSeriesPayload,
  SeriesOverlap,
} from 'app/typings/core/extranet/inventory/calendar';
import { apiMutation } from 'app/utils/request/api';

import { ENDPOINTS } from '.';

export function useValidateCreateSeries(hotelId?: number, calendarId?: number) {
  return useMutation({
    mutationFn: (payload: CreateSeriesPayload) =>
      hotelId !== undefined && calendarId !== undefined
        ? (apiMutation(
            'POST',
            {
              path: ENDPOINTS.validateCreateSeries,
              params: {
                hotelId: hotelId.toString(),
                calendarId: calendarId.toString(),
              },
            },
            payload
          ) as Promise<SeriesOverlap>)
        : Promise.reject(null),
  });
}
